import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './app/contexts/AuthContext';
import { TeamProvider } from './app/contexts/TeamContext';
import ProtectedRoute from './app/components/auth/ProtedtedRoute';
import MainLayout from './app/layouts/MainLayout';
import LandingPage from './landing/pages/LandingPage';
import Login from './app/pages/Login';
import SignUp from './app/pages/SignUp';
import PrivacyPolicy from './landing/pages/PrivacyPolicy';
import TermsOfUse from './landing/pages/TermsOfUse';
import ForgotPassword from './app/pages/ForgotPassword';
import Meetings from './app/pages/Meetings';
import CareerPlanning from './app/pages/CareerPlanning';
import Performance from './app/pages/Performance';
import { CssBaseline } from '@mui/material';

function App() {
  return (
    <>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <TeamProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfUse />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              {/* Protected Routes */}
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="meetings" replace />} />
                <Route path="meetings" element={<Meetings />} />
                <Route path="career" element={<CareerPlanning />} />
                <Route path="performance" element={<Performance />} />
              </Route>
            </Routes>
          </TeamProvider>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;